import { DeleteAccountRequestPage } from "@-/dev.improve.haniverse.routes.deleteme";

export default function DeleteMeRoute() {
  return <DeleteAccountRequestPage />;
}
